/**
 * The words of the note-learning block of the panel (contract v10.35), pure so the tests
 * pin them without rendering and the component file only exports a component.
 */
import type { NoteLearning } from '@/shared/triage/guidelines';

/**
 * Whose note it is, as the panel says it: «tu nota» only to whoever wrote it (`by_viewer`),
 * «la nota de Víctor» to anybody else, «la nota» when the back does not know who.
 */
export function noteOwner(learning: Pick<NoteLearning, 'by_viewer' | 'author'>): string {
  if (learning.by_viewer) return 'tu nota';
  return learning.author ? `la nota de ${learning.author}` : 'la nota';
}

/** While the worker distils the note: no spinner, the line is enough. */
export function learningText(learning: Pick<NoteLearning, 'by_viewer' | 'author'>): string {
  return `Aprendiendo de ${noteOwner(learning)}…`;
}

export function onlyThisEmailText(learning: Pick<NoteLearning, 'by_viewer' | 'author'>): string {
  const owner = noteOwner(learning);
  return `${owner.charAt(0).toUpperCase()}${owner.slice(1)} solo vale para este correo: no cambia nada de los siguientes.`;
}

export const TURNED_OFF_TEXT =
  'Lo que se aprendió de esta nota está desactivado: no cambia los siguientes correos.';

export const REPLACED_TEXT = 'Lo que se aprendió de esta nota lo ha sustituido una nota posterior.';
